// extracted by mini-css-extract-plugin
module.exports = {"content":"Header_content__2LxBc","middlecontent":"Header_middlecontent__1Zchw"};